import { typeof as _typeof } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useEffect } from 'react';

function useResizeObserver(_ref) {
  var target = _ref.target,
    onChange = _ref.onChange;
  useEffect(function () {
    var targetElement = isRef(target) ? target.current : target();
    if (!targetElement) {
      return;
    }
    var observer = new ResizeObserver(function () {
      return onChange === null || onChange === void 0 ? void 0 : onChange();
    });
    observer.observe(targetElement);
    return function () {
      return observer.disconnect();
    };
  }, []);
}
function isRef(obj) {
  return obj !== null && _typeof(obj) === 'object' && Object.prototype.hasOwnProperty.call(obj, 'current');
}

export { useResizeObserver };
//# sourceMappingURL=useResizeObserver.js.map
